import { render, staticRenderFns } from "./HorseCategorie.vue?vue&type=template&id=3d1dfb72&"
import script from "./HorseCategorie.vue?vue&type=script&lang=js&"
export * from "./HorseCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports